import * as React from "react";

const SlantedReactangle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="29px" viewBox="0 0 35 29" version="1.1">
            <title>rec -campaign</title>
            <g id="icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon
                    id="rec--campaign"
                    fill="currentcolor"
                    points="28.3743531 0.522758305 34.7910198 0.522758305 6.68791107 28.5227583 0.271244402 28.5227583"
                />
            </g>
        </svg>
    );
};

export default React.memo(SlantedReactangle);
